import { render, staticRenderFns } from "./VoucherSegmentClientFileModal.vue?vue&type=template&id=48d2bad1&scoped=true"
import script from "./VoucherSegmentClientFileModal.vue?vue&type=script&lang=js"
export * from "./VoucherSegmentClientFileModal.vue?vue&type=script&lang=js"
import style0 from "./VoucherSegmentClientFileModal.vue?vue&type=style&index=0&id=48d2bad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2bad1",
  null
  
)

export default component.exports